import { render } from "./UnitsFilterDropdownButton.vue?vue&type=template&id=2f8c6765"
import script from "./UnitsFilterDropdownButton.vue?vue&type=script&lang=js"
export * from "./UnitsFilterDropdownButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__